import React = require("react");
import Switch, {ReactSwitchProps} from "react-switch";
import {ToolbarContextInterface} from "../toolsbar/ToolbarContext";
import {defaultTheme} from "@vebox/etui-themes";
import {height, maxHeight, ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../../index";

interface SwitchWrapperState {
    checked: boolean;
    enabled: boolean;
}

export interface SwitchWrapperProps {
    switchProps: ReactSwitchProps;
    afterChange: (checked: boolean) => void;
    uncheckedIconClass?: string;
    checkedIconClass?: string;
    label?: string;
}

export class SwitchWrapper extends React.Component<SwitchWrapperProps, SwitchWrapperState> {
    constructor(props) {
        super(props);
        this.state = {
            checked: props.switchProps.checked,
            enabled: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    public render() {
        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                <label>
                    {this.props.label && <span>{this.props.label}</span>}
                    <Switch
                        onChange={this.handleChange}
                        checked={this.state.checked}
                        uncheckedIcon={this.props.uncheckedIconClass &&
                        (
                            <div className={this.props.uncheckedIconClass}/>
                        )}
                        checkedIcon={this.props.checkedIconClass &&
                        (
                            <div className={this.props.checkedIconClass}/>
                        )}
                        width={this.props.switchProps.width}
                        height={this.props.switchProps.height}
                        offColor={this.props.switchProps.offColor}
                        onColor={this.props.switchProps.onColor}
                        disabled={!this.state.enabled}
                        handleDiameter={this.props.switchProps.handleDiameter}
                    />
                </label>
            </ThemeProvider>
        );
    }

    private afterChange() {
        this.props.afterChange(this.state.checked);
    }

    private handleChange(checked): void {
        this.setState({checked}, this.afterChange);
    }
}
